export { Divider } from '@mantine/core'